import objectFitImages from 'object-fit-images';
document.addEventListener('DOMContentLoaded', function() {
    let homepageGrid = document.querySelector('.homepage-grid');
    if (homepageGrid !== null) {
        let initFunction = require('./homepage-grid.js');
        initFunction(homepageGrid);
    }
    let journalGrid = document.querySelector('.journal main');
    if (journalGrid !== null) {
        require('./journal.js').setup(journalGrid);
    }
    let checkoutForm = document.querySelector('body.checkout form');
    if (checkoutForm !== null) {
        require('./checkout.js').setup(checkoutForm);
    }
    objectFitImages();
    let homeVidLink = document.querySelector('.vidlink.home');
    if (homeVidLink !== null) {
        var initFunction = require('./homevid.js')
        initFunction(homeVidLink);
    }
    let checkedMinicartToggle = document.querySelector('#minicart-toggler:checked');
    if (checkedMinicartToggle !== null) {
        window.setTimeout(function() {
            checkedMinicartToggle.checked = false;
        }, 5000);
    }

    let itemsInCart = document.querySelector('.items-in-cart span');
    let miniCartTogglerLabel = document.querySelector('[for=minicart-toggler]');
    if (itemsInCart !== null && miniCartTogglerLabel !== null) {
        console.log(itemsInCart.innerHTML)
        miniCartTogglerLabel.dataset.itemsInCart = itemsInCart.innerHTML;
    }
})

window.initMap = function() {
    require('./map.js')(document.querySelector('.contact-details .map'))
}